<template>
  <div>
    <vx-card  v-if="user">
      <b-modal id="deleteUserModal" centered>
        <template #modal-header><h4>Usuwanie użytkownika</h4></template>
          Czy na pewno chcesz usunąć użytkownika {{user.first_name}} {{user.last_name}}?
        <template #modal-footer>
          <vs-button type="border round" icon-pack="feather" icon="icon-x"
                     @click="$bvModal.hide('deleteUserModal')">
            Anuluj
          </vs-button>
          <vs-button color="danger" type="filled round" icon-pack="feather" icon="icon-trash"
                     @click="deleteUser" class="mr-4">
            Usuń
          </vs-button>
        </template>
      </b-modal>
      <b-container fluid>
        <b-row class="mt-6">
          <b-col><h4>{{ user ? user.first_name+' '+user.last_name : '' }}</h4></b-col>
          <b-col v-if="$acl.check('admin')">
            <vs-button icon-pack="feather" icon="icon-save"
              v-if="!disabledForm" type="filled round" class="float-right ml-4" @click="updateUserForm">
             Zapisz
            </vs-button>
            <vs-button type="border round" class="float-right" icon-pack="feather" :icon="disabledForm ? 'icon-edit-2' : 'icon-x'"
                       @click="toggleFormEdit">
              {{ disabledForm ? 'Edytuj' : 'Anuluj' }}
            </vs-button>
             <vs-button  color="danger" type="border round" icon-pack="feather" icon="icon-trash"
                         v-if="disabledForm" class="float-right mr-4" @click="$bvModal.show('deleteUserModal')">
             Usuń użytkownika
            </vs-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col><h5 class="mt-8">Dane osobowe</h5></b-col>
        </b-row>
        <b-row>
          <!-- FIRST COLUMN -->
          <b-col md="6" cols="12">
            <b-row>
              <b-col>
                <vs-input
                  :disabled="disabledForm"
                  label="Email"
                  v-model="user.email"
                  class="w-100 mt-4"
               />
                <field-error :errorsBag="formErrors" fieldName="email" />
              </b-col>
            </b-row>
             <b-row>
              <b-col>
               <vs-input
                  :disabled="disabledForm"
                  label="Imię"
                  v-model="user.first_name"
                  class="w-100 mt-4"
               />
                <field-error :errorsBag="formErrors" fieldName="first_name" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <vs-input
                  :disabled="disabledForm"
                  label="Nazwisko"
                  v-model="user.last_name"
                  class="w-100 mt-4"
               />
                <field-error :errorsBag="formErrors" fieldName="last_name" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-select
                  :disabled="disabledForm"
                  :options="genderItems"
                  v-model="user.gender"
                  class="w-100 mt-4 h-12"
                />
                <field-error :errorsBag="formErrors" fieldName="gender" />
              </b-col>
            </b-row>
          </b-col>
          <!-- SECOND COLUMN -->
          <b-col md="6" cols="12">
            <b-row>
              <b-col>
                <vs-input
                  :disabled="disabledForm"
                  label="Powiat"
                  v-model="user.province"
                  class="w-100 mt-4"
               />
                <field-error :errorsBag="formErrors" fieldName="province" />
              </b-col>
            </b-row>
             <b-row>
              <b-col>
                <vs-input
                  :disabled="disabledForm"
                  label="Nazwa instytucji"
                  v-model="user.employment_company"
                  class="w-100 mt-4"
               />
                <field-error :errorsBag="formErrors" fieldName="employment_company" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-select
                  :disabled="disabledForm"
                  :options="employmentPositionItems"
                  v-model="user.employment_position"
                  class="w-100 mt-4 h-12"
                />
                <field-error :errorsBag="formErrors" fieldName="employment_position" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <vs-input
                  v-if="user.employment_position === 'lekarz'"
                  :disabled="disabledForm"
                  label="Nr licencji wykonywania zawodu"
                  v-model="user.license_number"
                  class="w-100 mt-4"
               />
                <field-error :errorsBag="formErrors" fieldName="license_number" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col><h5 class="mt-8">Uprawnienia</h5></b-col>
        </b-row>
        <b-row>
          <b-col md="6" cols="12">
            <b-form-select
              :disabled="disabledForm"
              :options="userTypeItems"
              v-model="user.type"
              class="w-100 my-4 h-12"
            />
            <field-error :errorsBag="formErrors" fieldName="type" />
          </b-col>
        </b-row>
      </b-container>
    </vx-card>
  </div>
</template>

<script>
import {manageUser, userFormItems} from './../../mixins/users/usersMixin'
import FieldError from './../../components/wod/forms/FieldError'

export default {
  name: "UsersSingle",
  components:{
    FieldError
  },
  mixins: [manageUser,userFormItems],
  data() {
    return {
      formErrors:{}
    }
  },
  methods: {
    clearFormError(){
      this.formErrors = {}
    },
    updateUserForm(){
      this.clearFormError()
      this.updateUser()
    }
  }
}

</script>

<style scoped>

</style>

